/**
 * @generated SignedSource<<bb968933f45ebb17b806745cdd66bb44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HistoryEventKind = "AccountLinked" | "CartUpdate" | "ClaimEmailResent" | "CustomerDetailsUpdate" | "InvoiceEmailCorrected" | "InvoiceResent" | "InvoiceSent" | "OrderClosedByAdmin" | "OrderCreated" | "PaymentInProcess" | "PaymentMethod" | "Purchase" | "PurchaseAwaitingAccount";
import { FragmentRefs } from "relay-runtime";
export type orderHistoryEvent_OrderHistoryFragment$data = {
  readonly closedBy?: {
    readonly email: string;
    readonly name: string;
  } | null;
  readonly closedByUserId?: string;
  readonly correctedBy?: {
    readonly email: string;
    readonly name: string;
  } | null;
  readonly correctedByUserId?: string;
  readonly invoiceId?: string;
  readonly invoiceNumber?: string;
  readonly kind: HistoryEventKind;
  readonly newInvoiceEmail?: string;
  readonly previousInvoiceEmail?: string;
  readonly reason?: string;
  readonly sentBy?: {
    readonly email: string;
    readonly name: string;
  } | null;
  readonly sentByUserId?: string;
  readonly sentToInvoiceEmail?: string;
  readonly when: string;
  readonly " $fragmentType": "orderHistoryEvent_OrderHistoryFragment";
};
export type orderHistoryEvent_OrderHistoryFragment$key = {
  readonly " $data"?: orderHistoryEvent_OrderHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"orderHistoryEvent_OrderHistoryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentToInvoiceEmail",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentByUserId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "sentBy",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "orderHistoryEvent_OrderHistoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "when",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiceId",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "InvoiceSentEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previousInvoiceEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newInvoiceEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correctedByUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "correctedBy",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "type": "InvoiceEmailCorrectedEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "type": "ClaimEmailResentEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "type": "InvoiceResentEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closedByUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "closedBy",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "type": "OrderClosedByAdminEvent",
      "abstractKey": null
    }
  ],
  "type": "HistoryEvent",
  "abstractKey": "__isHistoryEvent"
};
})();

(node as any).hash = "5d2b0c3737c1ffd6563f48e1f5627f2d";

export default node;
